import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { Tutorial, TutorialCategory } from 'types'
import { sendToApi } from 'api/client'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'
import qs from 'qs'

interface Data {
  tutorials: Tutorial[]
}

const fetchTutorials = async (props?: Props) => {
  let params = {}
  if (props?.categories) {
    params = { category: props.categories }
  }
  const response = await sendToApi<Data>(`/tutorials`, {
    params,
    stringify: (obj) => qs.stringify(obj, { arrayFormat: 'brackets' }),
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to fetch tutorials', {
      metaData: {
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

interface Props {
  categories?: TutorialCategory[] | TutorialCategory
}

export const useTutorials = (props?: Props, options?: UseQueryOptions<Data>) => {
  return useQuery<Data>(['tutorials', 'list', props], async () => fetchTutorials(props), {
    refetchOnWindowFocus: false,
    staleTime: (options?.cacheTime || 0) * 0.5,
    ...options,
  })
}
